import React from 'react';
import styles from '../../css/Part4.module.css';

function LoyaltyProgram() {
  return (
    <section className={styles.loyaltyProgram}>
      <div className={styles.background}>
        <div className={styles.container}>
          <h1 className={styles.mainHeading}>Wish to be one<br />of them?</h1>
          <p className={styles.description}>
            FoneApp uses the concept of recycling community's spending to reward its users. Every FoneApp user will be given a community structure of 21,844.
            <br /><br />
            Whenever your community spends, you will earn 0.1%, accumulated monthly. Ultimately, you're earning points that can be converted monetarily within FoneApp.
          </p>
          <div className={styles.imageGrid}>
            <div className={styles.grid}>
              <div className={styles.gridItem}>
                <picture>
                  <source media="(max-width: 500px)" srcSet="images/Testimonial/mobiletest1.png" />
                  <source media="(min-width: 500px)" srcSet="images/Testimonial/desktoptest1.png" />
                  <img
                    src="images/Testimonial/desktoptest1.png"
                    alt="User Testimonial 1"
                    className={styles.gridImage}
                  />
                </picture>
              </div>
              <div className={styles.gridItem}>
                <picture>
                  <source media="(max-width: 500px)" srcSet="images/Testimonial/mobiletest2.png" />
                  <source media="(min-width: 500px)" srcSet="images/Testimonial/desktoptest2.png" />
                  <img
                    src="images/Testimonial/desktoptest2.png"
                    alt="User Testimonial 2"
                    className={styles.gridImage}
                  />
                </picture>
              </div>
              <div className={styles.gridItem}>
                <picture>
                  <source media="(max-width: 500px)" srcSet="images/Testimonial/mobiletest3.png" />
                  <source media="(min-width: 500px)" srcSet="images/Testimonial/desktoptest3.png" />
                  <img
                    src="images/Testimonial/desktoptest3.png"
                    alt="User Testimonial 3"
                    className={styles.gridImage}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LoyaltyProgram;
